import React from "react";
import { Sparkles, X } from "lucide-react";
import { useBooking } from "../context/BookingContext";

export function PromoBanner({ visible, onClose }) {
  const { openBooking } = useBooking();
  if (!visible) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-[60] h-10 iri-gradient flex items-center justify-center px-10"
      data-testid="promo-banner"
    >
      <button
        onClick={() => openBooking("Complimentary Consultation")}
        data-testid="promo-banner-cta"
        className="group flex items-center gap-2 text-ink text-xs sm:text-sm font-medium"
      >
        <Sparkles className="h-3.5 w-3.5 shrink-0" />
        <span className="truncate">
          First-time guest? Enjoy a <span className="underline underline-offset-2">complimentary consultation</span>
          <span className="hidden sm:inline"> — a $249 value</span>
        </span>
        <span className="hidden md:inline opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all">
          · Claim offer →
        </span>
      </button>
      <button
        onClick={onClose}
        aria-label="Dismiss offer"
        data-testid="promo-banner-close"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-ink/70 hover:text-ink transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
